import { render } from "./SkeletonForCard.vue?vue&type=template&id=f4a93c12"
import script from "./SkeletonForCard.vue?vue&type=script&lang=js"
export * from "./SkeletonForCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__